import React from 'react'
import styled, { keyframes, css } from 'styled-components'
import { Link } from 'gatsby'

import { ArrowIcon } from '@/components/ui/icons'
import { GradientText } from '@/components/ui/gradient-text'
import { useTheme } from '@/styles'

type ContainerProps = {
  isCentered?: boolean
}

const Container = styled.div<ContainerProps>`
  display: flex;
  align-items: center;

  svg {
    margin-left: 0;
    transition: margin-left 200ms ease;
  }

  &:hover {
    svg {
      margin-left: 5px;
      transition: margin-left 200ms ease;
    }
  }

  ${({ isCentered }) =>
    isCentered &&
    css`
      transition: margin-left 200ms ease;

      &:hover {
        margin-left: 5px;
        transition: margin-left 200ms ease;
      }
    `}
`

const slideAnimation = keyframes`
    from {background-position: 0;}
    to {background-position: -300%;}
`

const ExtendedLink = styled(Link)`
  text-decoration: none;
  font-size: 16px;
  font-family: 'PT Mono', monospace;
  line-height: 22px;
  margin-right: 5px;
  position: relative;
  border-bottom: none;

  &::after {
    content: '';
    width: 100%;
    height: 1px;
    background: linear-gradient(
      to right,
      ${({ theme }) => theme.palette.giphyLightBlue},
      ${({ theme }) => theme.palette.giphyAqua}
    );
    background-size: 100%;
    background-position: 0 100%;
    position: absolute;
    bottom: 0;
    left: 0;
  }

  &:hover span,
  &:hover::after {
    background: linear-gradient(
      to right,
      ${({ theme }) => theme.palette.giphyLightBlue},
      ${({ theme }) => theme.palette.giphyAqua},
      ${({ theme }) => theme.palette.giphyLightBlue}
    );
    background-size: 300%;
    background-position: 0 100%;
    animation: ${slideAnimation} 3s infinite linear;
  }

  &:hover span {
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  span {
    display: block;
  }
`

type GradientLinkProps = {
  text: string
  url: string
  isCentered?: boolean
}

export const GradientLink = ({ text, url, isCentered }: GradientLinkProps) => {
  const { palette } = useTheme()

  return (
    <Container isCentered={isCentered}>
      <ExtendedLink to={url}>
        <GradientText>{text}</GradientText>
      </ExtendedLink>
      <ArrowIcon rotate={270} size={{ width: 12, height: 10 }} color={palette.giphyAqua} />
    </Container>
  )
}
